import gql from 'graphql-tag'
export default gql`
mutation deleteUserServiceMapping(
  $serviceId: String!
  $userId: String!
){
deleteUserServiceMapping(input: {
  serviceId: $serviceId
  userId: $userId
})
}
`

    